export default [
  {
    path: '/',
    redirect: '/account',
  },
  {
    path: '/account',
    component: () =>
      import(/* webpackChunkName: "PageAccountIndex" */ '~pages/Account/Index'),
    name: 'account',
  },
  {
    path: '/orgs',
    component: () =>
      import(
        /* webpackChunkName: "PageOrganizations" */ '~pages/Account/Organizations'
      ),
    name: 'organizations',
    children: [
      {
        path: ':id/edit',
        name: 'organization.edit',
        components: {
          sidebar: () =>
            import(
              /* webpackChunkName: "PageOrganizationEdit" */ '~pages/Account/OrganizationEdit'
            ),
        },
        props: { sidebar: (route) => ({ id: route.params.id }) },
      },
      {
        path: ':id/subscriptions',
        name: 'subscription.edit',
        components: {
          sidebar: () =>
            import(
              /* webpackChunkName: "OrganizationSubscriptions" */ '~pages/Account/OrganizationSubscriptions'
            ),
        },
        props: {
          sidebar: (route) => ({
            id: route.params.id,
            subscription: route.params.subscription,
          }),
        },
      },
    ],
  },
  {
    path: '/delete/:token',
    name: 'delete-organization',
    component: () =>
      import(
        /* webpackChunkName: "PageDeleteOrganizationConfirmation" */ '~pages/Account/DeleteOrganizationConfirmation'
      ),
    props: (route) => ({ token: route.params.token }),
  },
]
